import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import FormControl from "@material-ui/core/FormControl";
import Notification from "../notification/Notification";
import removeDuplicateFromArrayOfObjectByField from "../../../utils/removeDuplicateFromArrayOfObjectByField";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { removeDuplicatesFromConnectionsCollectionByServiceId } from "../../../utils/collections";
import { parseAxiosError } from "../../../utils/response";

const ServiceRelationshipsSelectForTransfer = ({
  setCheckedServiceRelationships,
  isObject = true,
  defaultOption = false
}) => {

  const [userConnections, setUserConnections] = useState(null);
  const [currency, setCurrency] = useState(null);

  const [checkedService, setCheckedService] = useState(null);
  const [checkedCurrency, setCheckedCurrency] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchServiceRelationshipsByServiceName = (data) => {
    axios.get("/api/service-relationships?service.name=" + data.name, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        let currency = [];

        response.data["hydra:member"].forEach(item => {
          currency.push(item.currency);
        });

        setCurrency(removeDuplicateFromArrayOfObjectByField(currency, "asset"));

        setCheckedServiceRelationships({
          "service": data,
          "currency": null
        });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const fetchServices = () => {
    axios.get("/api/connections?pagination=false", userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK && "hydra:member" in response.data) {
        setUserConnections(response.data["hydra:member"]);

        setCurrency(null);

        setCheckedServiceRelationships({
          "service": null,
          "currency": null
        });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleChangeCurrencySelect = (data) => {
    setCheckedCurrency(data);

    setCheckedServiceRelationships({
      "service": checkedService,
      "currency": data
    });
  };

  const handleChangeServiceSelect = (data) => {
    setCheckedService(data);
    fetchServiceRelationshipsByServiceName(data);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <>
        <FormControl>
          <Autocomplete
            options={
              userConnections
                ? isObject
                  ? removeDuplicatesFromConnectionsCollectionByServiceId(userConnections).map(connection => connection.service)
                  : removeDuplicatesFromConnectionsCollectionByServiceId(userConnections).map(connection => connection.service.name)
                : []
            }
            value={checkedService || null}
            onChange={(event, checkedService) => handleChangeServiceSelect(checkedService)}
            getOptionLabel={(option) => isObject ? option.name : option}
            renderInput={(params) => (
              <TextField {...params} label="Сервис" />
            )}
            blurOnSelect
            disableClearable={!defaultOption}
          />
        </FormControl>
      </>
      {currency && Object.keys(currency).length !== 0 &&
        <>
          <FormControl>
            <Autocomplete
              options={(isObject ? currency : currency.map(currency => currency.asset)) || []}
              value={checkedCurrency || null}
              onChange={(event, checkedCurrency) => handleChangeCurrencySelect(checkedCurrency)}
              getOptionLabel={(option) => isObject ? option.asset : option}
              renderInput={(params) => (
                <TextField {...params} label="Валюта" />
              )}
              blurOnSelect
              disableClearable={!defaultOption}
            />
          </FormControl>
        </>
      }
    </>
  );
};

export default ServiceRelationshipsSelectForTransfer;